import { Injectable } from '@angular/core';
import ExcellentExport from 'excellentexport';

@Injectable()
export class ExcelService {

    constructor() { }

    public exportAsExcelFile(json: any[], excelFileName: string): void {
        if (!json || json.length === 0) {
            console.warn('No data to export');
            return;
        }

        // Convert JSON to array format: [ [header1, header2, ...], [value1, value2, ...], ... ]
        const headers = Object.keys(json[0]);
        const dataArray = [headers, ...json.map(row => headers.map(header => row[header]))];

        // Create a temporary anchor element
        const anchor = document.createElement('a');
        document.body.appendChild(anchor);

        // Trigger Excel download
        ExcellentExport.convert(
            {
                anchor,
                filename: `${excelFileName}_${new Date().toDateString()}`,
                format: 'xlsx'
            },
            [
                {
                    name: 'data',
                    from: {
                        array: dataArray
                    }
                }
            ]
        );
        anchor.click();
        // Clean up
        document.body.removeChild(anchor);
    }
}
